import http from '@gp/utils/httpTS';

import type { KeyMetricsListType, ScheduleListType } from '@gp/types/overview';
import type { ICalendarTableDTO } from '@gp/types/calendar';

const convertFetchParams = (params?: IPipelineOverviewScheduleFetchParams | null) => {
  const { studio: studios, project: projects, ...restParams } = params || {};
  return { ...restParams, studios, projects };
};

const convertDownloadParams = (params?: IPipelineOverviewScheduleDownloadParams | null) => {
  const { schedule_req: scheduleReq, ...restParams } = params || {};
  return { ...restParams, schedule_req: convertFetchParams(scheduleReq) };
};

export const getScheduleFilterMessage = (): Promise<IPipelineOverviewScheduleFilterConditionsDTO> => {
  return http({
    url: '/api/v1/globalpedia_pc/dashboard_scheduler_condV2',
    method: 'GET',
    formatData: (res: any) => {
      const { bo: businessOwners, ...restRes } = res || {};
      return { ...restRes, business_owner: businessOwners };
    },
  }) as any;
};

export const getNewKeyMetrics = (): Promise<KeyMetricsListType> => {
  return http({ url: '/api/v1/globalpedia_pc/dashboard/key_metrics', method: 'GET' }) as any;
};

export const getScheduleList = (params?: IPipelineOverviewScheduleFetchParams | null): Promise<ScheduleListType> => {
  return http({ url: '/api/v1/globalpedia_pc/scheduleV2', method: 'POST', data: convertFetchParams(params) }) as any;
};

export const scheduleListDownload = (params?: IPipelineOverviewScheduleDownloadParams | null) => {
  return http({
    url: '/api/v1/globalpedia_pc/schedule_downloadV2',
    method: 'POST',
    data: convertDownloadParams(params),
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
    // timeout: 24 * 60 * 60 * 1000, // 一天，限制的请求允许持续时间
    // maxContentLength: 100 * 1024 * 1024 * 1024, // 100G，限制的请求允许响应最大资源大小
  });
};

export const getScheduleMonthlyList = (
  params?: IPipelineOverviewScheduleFetchParams | null,
): Promise<{ start: string; end: string; list: ICalendarTableDTO[] }> => {
  return http({
    url: '/api/v1/globalpedia_pc/schedule_monthly',
    method: 'POST',
    data: convertFetchParams(params),
  }) as any;
};

export const downloadScheduleMonthlyList = (params?: IPipelineOverviewScheduleDownloadParams | null) => {
  return http({
    url: '/api/v1/globalpedia_pc/schedule_monthly_download',
    method: 'POST',
    data: convertDownloadParams(params),
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
    // timeout: 24 * 60 * 60 * 1000, // 一天，限制的请求允许持续时间
    // maxContentLength: 100 * 1024 * 1024 * 1024, // 100G，限制的请求允许响应最大资源大小
  }) as any;
};
